<template>
  <div class="page-students">
    <div class="students-search">
      <span class="search-label">学员姓名：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="name"
        placeholder="请输入内容"
      ></el-input>
      <span class="search-label">学员手机号：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="phone"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="students-add">
      <el-button size="small" type="primary" @click="handleImport">
        导入
      </el-button>
    </div>
    <div class="students-table">
      <el-table
        :data="studentsList"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button v-if="item.prop === 'phone'" type="text" @click="handleViewPhone(scope.row, scope.$index)">{{ scope.row.phone || '--' }}</el-button>
            <span v-else>
              {{
                item.prop === 'status'
                  ? scope.row.status === 1
                    ? '启用'
                    : '禁用'
                  : scope.row[item.prop]
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="70"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleEditor(scope.row)">
              编辑
            </el-button>
            <el-button type="text" @click="handleState(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" @click="handleDel(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="students-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <ImportStudents v-if="importFlag" :handleClose="handleImportClose" />
    <StudentsWrite
      v-if="writeDialogFlag"
      :defaultData="writeDialogData"
      :handleClose="handleCloseWriteDialog"
    />
  </div>
</template>
<script>
import { column } from './assets'
import ImportStudents from './importStudents.vue'
import StudentsWrite from './writeDialog.vue'
import { getPhoneById } from '../../api/api'
import * as API from '../../api/students/index'
export default {
  name: 'StudentsManage',
  components: { ImportStudents, StudentsWrite },
  data() {
    return {
      column,
      name: '',
      phone: '',
      limit: 10,
      page: 1,
      total: 0,
      studentsList: [],
      loading: false,
      importFlag: false,
      writeDialogFlag: false,
      writeDialogData: {}
    }
  },
  created() {
    this.getStudentsList()
  },
  methods: {
    async getStudentsList() {
      this.loading = true
      try {
        const { page, limit, name, phone } = this
        const params = { page, limit, name, phone }
        const res = await API.getStudentsList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.studentsList = records
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getStudentsList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getStudentsList()
    },
    handleSearch() {
      this.page = 1
      this.getStudentsList()
    },
    handleReset() {
      this.page = 1
      this.name = ''
      this.phone = ''
      this.getStudentsList()
    },
    handleImport() {
      this.importFlag = true
    },
    handleImportClose(bool) {
      this.importFlag = false
      if (bool) this.handleReset()
    },
    handleEditor(row) {
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    handleCloseWriteDialog(bool) {
      this.writeDialogFlag = false
      if (bool) this.getStudentsList()
    },
    async handleState(row) {
      const { id, status, name } = row
      this.$confirm(`确认要${status === 1 ? '禁用' : '启用'}${name}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const data = { id, status: status === 1 ? 2 : 1 }
          const res = await API.stateStudent(data)
          const { code } = res
          if (code === 0) {
            this.$message.success(`${status === 1 ? '禁用' : '启用'}成功`)
            this.getStudentsList()
          }
        })
        .catch(() => {})
    },
    handleDel(row) {
      const { id, name } = row
      this.$confirm(`确认要删除学员${name}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const data = { id }
            const res = await API.delStudent(data)
            const { code } = res
            if (code === 0) {
              this.$message.success('删除成功')
              this.getStudentsList()
            }
          } catch (error) {}
        })
        .catch(() => {})
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getPhoneById({ id: row.id }).then(({ code, data }) => {
        if (code === 0) {
          this.studentsList.forEach((item, i) => {
            if (i === index) {
              item.phone = data
            }
          })
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.page-students {
  background: #fff;
  padding: 20px;
  .students-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 20px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .students-add {
    margin-bottom: 20px;
    text-align: right;
  }
  .students-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
